import React from 'react';
import { PILOT_URL } from '../constants';
import styles from './LandingNavContent.module.scss';

const LandingNavContent: React.FC = () => (
  <>
    <nav aria-label="Main navigation" className={styles.navLinks}>
      <a href="#features">Features</a>
      <a href="#who">Who can Use</a>
      <a href="#roadmap">Roadmap</a>
      <a href="#ast-vs-langhub">AST vs LangHub</a>
    </nav>
    <a
      className={styles.onboardBtn}
      href={PILOT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Join Pilot (opens in new tab)"
    >
      Join Pilot
    </a>
  </>
);

export default LandingNavContent;
